import { useEffect, useState } from 'react'
import { api } from '../lib/api'

const Deployments = () => {
  const [deployments, setDeployments] = useState([])
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const load = async () => {
      try {
        const data = await api.getDeployments()
        setDeployments(data)
      } catch (err) {
        setError(err.message || 'Failed to load deployments')
      } finally {
        setLoading(false)
      }
    }

    load()
  }, [])

  return (
    <div className="space-y-8">
      <div className="flex flex-col gap-2">
        <div className="text-xs uppercase tracking-widest text-slate-500">Deployments</div>
        <h1 className="text-3xl font-semibold">Deployment timeline</h1>
        <p className="text-slate-600">Track build status, rollout progress, and logs in one view.</p>
      </div>

      <div className="rounded-3xl border border-slate-200 bg-white/85 p-6 shadow-sm">
        <div className="mb-4 flex items-center justify-between">
          <div className="text-sm font-semibold">Latest deployments</div>
          <button className="rounded-full border border-slate-300 px-4 py-2 text-xs font-semibold text-ink">
            Refresh
          </button>
        </div>

        {loading ? (
          <div className="rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-500">
            Loading deployments...
          </div>
        ) : null}

        {error ? (
          <div className="rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-600">
            {error}
          </div>
        ) : null}

        <div className="space-y-4">
          {deployments.map((deployment) => (
            <div key={deployment.id} className="flex items-center justify-between rounded-2xl border border-slate-200 bg-slate-100 p-4">
              <div>
                <div className="text-sm font-semibold">{deployment.projectId || 'project'}</div>
                <div className="text-xs text-slate-500">
                  {deployment.id} � {deployment.createdAt ? new Date(deployment.createdAt).toLocaleString() : 'recent'}
                </div>
              </div>
              <div className="rounded-full border border-slate-200 bg-white px-3 py-1 text-xs font-semibold text-ink">
                {deployment.status}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="grid gap-4 md:grid-cols-3">
        <div className="rounded-2xl border border-slate-200 bg-white/85 p-5">
          <div className="text-xs uppercase tracking-widest text-slate-500">Build</div>
          <div className="mt-3 text-xl font-semibold">Status</div>
          <p className="mt-2 text-xs text-slate-500">Monitor Cloud Build progress.</p>
        </div>
        <div className="rounded-2xl border border-slate-200 bg-white/85 p-5">
          <div className="text-xs uppercase tracking-widest text-slate-500">Deploy</div>
          <div className="mt-3 text-xl font-semibold">Rollout</div>
          <p className="mt-2 text-xs text-slate-500">Track Cloud Run revisions.</p>
        </div>
        <div className="rounded-2xl border border-slate-200 bg-white/85 p-5">
          <div className="text-xs uppercase tracking-widest text-slate-500">Rollbacks</div>
          <div className="mt-3 text-xl font-semibold">Safe</div>
          <p className="mt-2 text-xs text-slate-500">Instant rollback support.</p>
        </div>
      </div>
    </div>
  )
}

export default Deployments
